import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, takeUntil, timeout } from 'rxjs';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class ImageHelperService {

  constructor(private baseService: BaseService) { }

  async formHasImage<T>(formData: T,
    destroy$: Observable<any>) {

    try {
      const res = await firstValueFrom(
        this.baseService.addImage.pipe(
          timeout(3000),
          takeUntil(destroy$)
        )
      );
      const ImageId = res?.id;
      const imagekey = res?.formKey;
      // Update formData with ImageId if it exists
      if (ImageId && imagekey) {
        formData[imagekey] = ImageId;
        return formData;
      }
    } catch (err) {
      // Proceed without ImageId if no emission (image is optional)
    }
    return formData
  }
}
